type PopNavigationDirtyGuard = (nextUrl: URL) => boolean

let popNavigationDirtyGuard: PopNavigationDirtyGuard | null = null

if (typeof window !== "undefined") {
  window.addEventListener("popstate", (event) => {
    const guard = popNavigationDirtyGuard
    if (!guard) {
      return
    }

    if (guard(new URL(window.location.href))) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }, { capture: true })
}

export function setPopNavigationDirtyGuard(guard: PopNavigationDirtyGuard) {
  popNavigationDirtyGuard = guard
  return () => {
    if (popNavigationDirtyGuard === guard) {
      popNavigationDirtyGuard = null
    }
  }
}
